<template>
  <g>
    <path
      d="M16 9.00024C15.3 9.00024 14.63 9.10024 14 9.29024V7.00024C14 5.90024 13.1 5.00024 12 5.00024H4C2.9 5.00024 2 5.90024 2 7.00024V17.0002C2 18.1002 2.9 19.0002 4 19.0002H9.68C10.8 21.3602 13.21 23.0002 16 23.0002C19.87 23.0002 23 19.8702 23 16.0002C23 12.1302 19.87 9.00024 16 9.00024ZM16 21.0002C13.24 21.0002 11 18.7602 11 16.0002C11 13.2402 13.24 11.0002 16 11.0002C18.76 11.0002 21 13.2402 21 16.0002C21 18.7602 18.76 21.0002 16 21.0002Z"
    />
    <path
      d="M14 4.00024C14.55 4.00024 15 3.55024 15 3.00024C15 2.45024 14.55 2.00024 14 2.00024H11.5L10.79 1.29024C10.61 1.11024 10.35 1.00024 10.09 1.00024H5.91C5.65 1.00024 5.39 1.11024 5.21 1.29024L4.5 2.00024H2C1.45 2.00024 1 2.45024 1 3.00024C1 3.55024 1.45 4.00024 2 4.00024H14Z"
    />
    <path
      d="M15.75 12.0002C15.34 12.0002 15 12.3402 15 12.7502V16.4302C15 16.7902 15.19 17.1102 15.5 17.2902L18.02 18.7602C18.35 18.9502 18.77 18.8502 18.98 18.5402C19.21 18.2002 19.1 17.7302 18.74 17.5202L16.5 16.2002V12.7502C16.5 12.3402 16.16 12.0002 15.75 12.0002Z"
    />
  </g>
</template>
